import React, {createContext, useContext, useState, useEffect, useCallback, useRef} from 'react';
import { useAuth } from '../Contexts/AuthContext'; // adjust path as needed
import useApiService from './ApiService';
import CONFIG from "./CONFIG";

const OrganizarionApiContext = createContext();

export const OrganizationApiProvider = ({ children }) => {
    const { get, put } = useApiService(CONFIG.SERVER_ORGANIZATION);
    const auth = useAuth();

    const [organizations, setOrganizations] = useState([]);
    const organizationsRef = useRef(organizations);

    useEffect(() => {
        organizationsRef.current = organizations;
    }, [organizations]);

    const getOrganizations = useCallback(async (skip, limit) => {
        if (!skip) {
            skip = 0;
        }
        if (!limit) {
            limit = 10;
        }

        try {
            const response = await get(`/v1/organizations?skip=${skip}&limit=${limit}`);
            return response.data;
        }
        catch (error) {
            console.error("Error fetching organizations:", error);
            throw error;
        }
    }, [get, auth]);

    const getOrganizationById = useCallback(async (id, newFetch = false) => {
        if (!newFetch) {
            const cache = organizationsRef.current.find(org => org.id === id);
            if (cache) return cache;
        }

        try {
            const response = await get(`/v1/organizations/${id}`);
            const newOrg = response.data;

            setOrganizations((prev) => {
                const exists = prev.some(org => org.id === newOrg.id);
                if (exists) {
                    return prev.map(org => org.id === newOrg.id ? newOrg : org);
                }
                return [...prev, newOrg];
            });
            return newOrg;
        }
        catch (error) {
            console.error("Error fetching organization by ID:", error);
            throw error;
        }

    }, [get]);

    const createOrganization = useCallback(async (body) => {
        const organization = await put("/v1/organizations", body);
        return organization;
    }, [put]);

    const updateOrganization = useCallback(async (id, organization) => {
        try {
            const response = await put(`/v1/organizations/${id}`, organization);
            return response.data;
        }
        catch (error) {
            console.error("Error updating organization:", error);
            throw error;
        }
    }, [put]);

    return (
        <OrganizarionApiContext.Provider value={{
            getOrganizations,
            getOrganizationById,
            createOrganization,
            updateOrganization,
        }}>
            {children}
        </OrganizarionApiContext.Provider>
    );
}

export const useOrganizationApi = () => {
    const context = useContext(OrganizarionApiContext);
    if (!context) {
        throw new Error("useOrganizationApi must be used within an OrganizationApiProvider");
    }
    return context;
}